export default __webpack_public_path__ + "_/images/marketplace/slot-boots-7b216442081d0d19430c452aeb354fa0b7ff0b6f5a43797f53f88935b0790f91.png";